import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { adminAuthService, type AdminLoginPayload } from '../services/adminAuth.service';
import { useAdminAuthStore } from '../../store/adminAuthStore';

export function useAdminLogin() {
  const setAdmin = useAdminAuthStore((s) => s.setAdmin);
  return useMutation({
    mutationFn: (payload: AdminLoginPayload) => adminAuthService.login(payload),
    onSuccess: (admin) => {
      setAdmin(admin);
      toast.success(`Welcome back, ${admin.firstName}`);
    },
    onError: (err: Error) => toast.error(err.message || 'Login failed'),
  });
}

export function useAdminLogout() {
  const setAdmin = useAdminAuthStore((s) => s.setAdmin);
  return useMutation({
    mutationFn: () => adminAuthService.logout(),
    onSettled: () => setAdmin(null),
  });
}
